<template>
  <page>
    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card>
            <v-card-text>
              <v-container fluid grid-list-lg>
                <v-layout row>
                  <v-flex xl3 lg4 xs6>
                    <v-text-field
                      v-model="filters.glAnType"
                      :label="labels.glAnType"
                      :error-messages="errors.collect('glAnType')"
                      data-vv-name="glAnType"
                      :data-vv-as="labels.glAnType"
                      v-validate="'max:16'"
                    ></v-text-field>
                    <v-text-field
                      v-model="filters.glAnCode"
                      :label="labels.glAnCode"
                      :error-messages="errors.collect('glAnCode')"
                      data-vv-name="glAnCode"
                      :data-vv-as="labels.glAnCode"
                      v-validate="'max:16'"
                    ></v-text-field>
                    <v-text-field
                      v-model="filters.glAnDesc"
                      :label="labels.glAnDesc"
                      :error-messages="errors.collect('glAnDesc')"
                      data-vv-name="glAnDesc"
                      :data-vv-as="labels.glAnDesc"
                      v-validate="'max:16'"
                    ></v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
              <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
            </v-card-actions>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-card-title>
        <v-spacer />
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New GL Analysis Code
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </v-card-title>
      <v-flex>
        <v-card>
          <v-data-table
            :headers="headers"
            :items="items"
            v-bind:options.sync="pagination"
            :server-items-length="totalItems"
            :loading="loading"
            :footer-props="{'items-per-page-options': itemsPerPage }"
            :no-data-text="noDataText"
          >
            <template v-slot:item="row"
              ><tr>
                <td class="text-xs-left">{{ row.item.glAnType }}</td>
                <td class="text-xs-left">{{ row.item.glAnCode }}</td>
                <td class="text-xs-left">{{ row.item.glAnDesc }}</td>
                <td class="table-action-header">
                  <table-action
                    :rowData="row"
                    review
                    @review="doReview(row.item)"
                    query
                    @query="doQuery(row.item)"
                    remove
                    @remove="doDelete(row.item)"
                  ></table-action>
                </td></tr
            ></template>
          </v-data-table>
        </v-card>
      </v-flex>
      <confirm ref="confirmDelete">
        <p>Are you sure you want to delete the selected GL Analysis Code?</p>
      </confirm>
    </v-card>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import * as TableConst from '@/mixins/table'
import { expandURI, filterQuery } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'GL Analysis Type', value: 'glAnType' },
        { text: 'GL Analysis Code', value: 'glAnCode' },
        { text: 'Description', value: 'glAnDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        glAnType: 'GL Analysis Type',
        glAnCode: 'GL Analysis Code',
        glAnDesc: 'Description'
      },
      filters: {
        glAnType: null
      },
      totalItems: 0,
      toogleArray: [false],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.fetchData(true)
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.menu.glAnCodeList
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map((glAnCode) => {
                const item = {
                  glAnType: glAnCode.glanType,
                  glAnCode: glAnCode.glanCode,
                  glAnDesc: glAnCode.glanDesc
                }
                this.items.push(item)
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doClearFilters() {
      this.filters.glAnType = null
      this.filters.glAnCode = null
      this.filters.glAnDesc = null
      this.fetchData(false)
    },
    doNew() {
      const commit = {
        glAnType: null,
        glAnCode: null,
        glAnDesc: null
      }
      sessionStorage.setItem('glAnCode', JSON.stringify(commit))
      this.$store.commit('GLANCODE_COMMIT_KEY', commit)
      this.$router.push({ name: 'glAnCodeNew' })
    },
    doReview(data) {
      if (data) {
        const commit = {
          glAnType: data.glAnType,
          glAnCode: data.glAnCode,
          glAnDesc: data.glAnDesc
        }
        sessionStorage.setItem('glAnCode', JSON.stringify(commit))
        this.$store.commit('GLANCODE_COMMIT_KEY', commit)
        this.$router.push({ name: 'glAnCodeDet', params: { glAnType: data.glAnType, glAnCode: data.glAnCode, glAnCodeMode: 'Review' } })
      }
    },
    doQuery(data) {
      if (data) {
        const commit = {
          glAnType: data.glAnType,
          glAnCode: data.glAnCode,
          glAnDesc: data.glAnDesc
        }
        sessionStorage.setItem('glAnCode', JSON.stringify(commit))
        this.$store.commit('GLANCODE_COMMIT_KEY', commit)
        this.$router.push({ name: 'glAnCodeDet', params: { glAnType: data.glAnType, glAnCode: data.glAnCode, glAnCodeMode: 'Query' } })
      }
    },
    async doDelete(data) {
      const prompt = await this.$refs.confirmDelete.doPopUp()
      if (!prompt) return
      const apiURI = this.menu.glAnCodeDelete
      if (data && apiURI) {
        const expand = {
          glAnType: data.glAnType,
          glAnCode: data.glAnCode
        }
        try {
          const result = await this.$http.delete(expandURI(apiURI, expand))
          const data = result.data
          this.fetchData(false)
          this.notify(data)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.glAnCode.menu
    }
  },
  mixins: [TableConst.default, MessageMixin],
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData(false)
    }
  }
}
</script>
